"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDocumentStateSigned = exports.defaultDocumentStatePending = void 0;
var DocumentTranslateState_init_1 = require("@/pages/document/states/DocumentTranslateState.init");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var EformState_init_1 = require("@/pages/document/states/EformState.init");
var EformStatus_1 = require("@/pages/document/states/EformStatus");
exports.defaultDocumentStatePending = {
    t: DocumentTranslateState_init_1.defaultDocumentTranslateState,
    resultT: ResultPageState_init_1.defaultResultPageTranslate,
    eforms: [
        EformState_init_1.defaultEformState1,
        EformState_init_1.defaultEformState2,
    ],
    currentPage: 1,
    totalPage: 1,
    totalItems: 0,
    isLoading: false
};
exports.defaultDocumentStateSigned = __assign(__assign({}, exports.defaultDocumentStatePending), { eforms: exports.defaultDocumentStatePending.eforms.map(function (it, i) {
        return __assign(__assign({}, it), { status: i % 2 === 1 ? EformStatus_1.EformStatus.COMPLETED : EformStatus_1.EformStatus.WAITING_OTHERS });
    }) });
